export function updateValueWithPercentage(
  value: string,
  percentage: number,
): string {
  if (!value) {
    return value;
  }

  if (value.includes('var(') || value.includes('--')) {
    return value;
  }

  // Extract numeric value from string (e.g., "10px" -> 10)
  const numericValue = parseFloat(value);

  if (isNaN(numericValue) || numericValue === 0) {
    return value;
  }

  // Check if original value is even
  const isEven = Math.round(numericValue) % 2 === 0;

  // Apply percentage
  let newValue = numericValue * (percentage / 100);

  // Round to nearest integer
  newValue = Math.round(newValue);

  // Ensure even numbers stay even
  if (isEven && newValue % 2 !== 0) {
    // Round to nearest even number
    newValue = Math.round(newValue / 2) * 2;
  }

  // Apply minimum of 1px (only if original wasn't 0)
  if (newValue < 1) {
    newValue = isEven ? 2 : 1;
  }

  return `${newValue}px`;
}

export function checkForMixedValues(
  currentValue: string | null,
  lastCheckedValue: string | null,
): boolean {
  return Boolean(
    lastCheckedValue && currentValue && lastCheckedValue !== currentValue,
  );
}
